import React, { useState, Fragment, useEffect } from 'react'
import {
    Card, Form, Col, Row, ListGroup, ListGroupItem, Button
} from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { downloadCSV } from './utils/utils';


export const CardTimeseriesSelection = ({ charts, setCharts, overallData, overallFueltypes, fuelTypeInfo, scenario, fleet }) => {
    const [csvHeaders, setCsvHeaders] = useState([])
    const [csvKeys, setCsvKeys] = useState([])
    useEffect(()=>{
        const _keys = ["year", "month", "capacity", "Tank-To-Wake", "Well-To-Tank", "capex", "capex_cumsum", "opex", "opex_cumsum", "nbunkering_relative", "nships", "nships_relative" ,"average_speed_kts", "el_energy"]
        const _headers = ["Year", "Month", "Transport capacity [ton.mile]", "Tank to wake CO2 emission [kTon]", "Well to tank CO2 emission [kTon]", "Capital expenditure [€]", 
        "Cumulative capital expenditure [€]", "Operational expenditure [€]", "Cumulative operational expenditure [€]", "Number of bunkerings relative to first month [%]", "Average number of ships sailing", 
        "Average number of ships sailing relative to first month [%]", "Average speed [kn]", "Total electric energy demand [GWh]"]
        overallFueltypes.forEach(element => {
            _keys.push(`consumption.${element.name}`)
            _headers.push(`Consumption ${fuelTypeInfo[element.name].short_display_name} [MWh]`)
        })
        overallFueltypes.forEach(element => {
            _keys.push(`fuel_price.${element.name}`)
            _headers.push(`Fuel price ${fuelTypeInfo[element.name].short_display_name} [€/kWh]`)
        })
        setCsvHeaders(_headers)
        setCsvKeys(_keys)
    },[overallFueltypes, fuelTypeInfo])

    //const [showWarning, setShowWarning] = useState(false)
    const [nSelected, setNSelected] = useState(4)

    const handleClick = (selectedC) => {

        let _nS = nSelected
        if (!selectedC.checked)
            _nS = _nS + 1
        else
            _nS = _nS - 1

        if (_nS > 10) {
            setCharts([...charts])
            toast.error('Max number of charts is selected!', {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setCharts([...charts])
            setNSelected(10)
        }
        else {
            let _charts = charts.filter(c => c.id !== selectedC.id)
            selectedC.checked = !selectedC.checked
            let final = [..._charts, selectedC]

            final = final.sort((a, b) => a.id - b.id)
            setCharts([...final])
            setNSelected(_nS)
        }

    }

    return (

        <Fragment>
            <Card
                style={{
                    position: 'absolute',
                    top: 255,
                    left: 20,
                    width: '20vw',
                    alignContent: 'center'
                }}>
                {/* {showWarning ?
                    <Row>

                        <Col><h6 style={{ margin: 20 }}>Too many charts are selected! </h6></Col>
                    </Row>
                    :
                    <></>
                } */}

                {/* <Card.Body className="d-flex justify-content-left"> */}
                <ListGroup variant="flush">
                <ListGroupItem>

                <Row>
                    <Col><h6>Select charts:</h6></Col>
                </Row>
                    <Form>
                        {
                            charts.map((c, idx) =>
                                <Form.Check // prettier-ignore
                                    type='checkbox'
                                    checked={c.checked}
                                    key={`chartcheck-${idx}`}
                                    onChange={() => handleClick(c)}
                                    id={c.id}
                                    label={c.name}
                                />
                            )
                        }
                    </Form>
                </ListGroupItem>
                <ListGroupItem>
                    <Button onClick={()=>{downloadCSV(`${scenario.region}-${scenario.name}-${fleet.fleet}.csv`, overallData, csvKeys, csvHeaders)}} className="w-100"><FaDownload /> Download data</Button>
                </ListGroupItem>
                </ListGroup>
                {/* </Card.Body> */}
            </Card>
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </Fragment>

    )
}